import { Controller } from "@hotwired/stimulus"

// Renders new sub-form rows from a server-rendered template string. The
// template contains the literal placeholder "NEW_RECORD" wherever
// child_index appears in the form names — we substitute a fresh
// Date.now() per inserted row so each accepted_nested submission gets a
// distinct child_index. Persisted rows get hidden via the _destroy field
// rather than removed from the DOM, so accepts_nested_attributes_for can
// pick them up on save.
export default class extends Controller {
  static values = { template: String, association: String }
  static targets = ["anchor", "row"]

  declare templateValue: string
  declare associationValue: string
  declare readonly anchorTarget: HTMLElement

  add(event: Event) {
    event.preventDefault()
    const html = this.templateValue.replace(/NEW_RECORD/g, Date.now().toString())
    this.anchorTarget.insertAdjacentHTML("beforebegin", html)
  }

  remove(event: Event) {
    event.preventDefault()
    const button = event.currentTarget as HTMLElement
    const row    = button.closest('[data-nested-rows-target="row"]') as HTMLElement | null
    if (!row) return

    const destroy = row.querySelector<HTMLInputElement>('[data-nested-rows-target="destroy"]')
    if (destroy) {
      // Persisted row: mark for destruction, hide from view.
      destroy.value = "1"
      row.style.display = "none"
    } else {
      // Unsaved row: just yank it.
      row.remove()
    }
  }
}
